import { StateType } from './store.types';

export default {
  loading: false,
  partners: [],
  form: {
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone: '',
    termsAndConditionsAgree: false,
    utmSource: null,
    utmMedium: null,
    utmCampaign: null,
  },
} as StateType;
